import { useFormik } from "formik";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import { useTranslation } from "react-i18next";
import { DeleteAccountValidation } from "./validations";
import PhoneInputField from "../../../molecules/formControls/inputField/PhoneInputField";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import TabsRoot from "../../../molecules/tabs/TabsRoot";
import { getCountryCode, getLocalPhoneNumber } from "../../../../helpers/utils";

const DeleteAccountForm = ({ isLoggedIn, attrMap, onSubmit }) => {
  const { t } = useTranslation();
  const countryCode = getCountryCode();

  const initialValues = {
    loginMethod: "email",
    email: attrMap?.email ?? "",
    phone_number: getLocalPhoneNumber(attrMap, countryCode) ?? "",
    countryCode: "+90",
    password: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: DeleteAccountValidation(
      t,
      countryCode,
      attrMap,
      isLoggedIn
    ),
    onSubmit: onSubmit,
  });

  const handleChangeTab = (value) => {
    formik.setFieldValue("loginMethod", value);

    if (value === "email") {
      formik.setTouched({
        ...formik.touched,
        phone_number: false,
        countryCode: false,
      });
    } else {
      formik.setTouched({
        ...formik.touched,
        email: false,
      });
    }
  };

  const tabsData = [
    {
      value: "email",
      label: t("signIn.email"),
      content: (
        <FloatingInputField
          id="email"
          name="email"
          label={t("signIn.email")}
          required={true}
          disabled={isLoggedIn}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          formikTouched={formik.touched.email}
          error={formik.errors.email}
        />
      ),
    },
    {
      value: "phone_number",
      label: t("signIn.phone"),
      content: (
        <PhoneInputField
          id="phone_number"
          name="phone_number"
          required={true}
          disabled={isLoggedIn}
          onChange={formik.handleChange}
          countryCode={countryCode}
          onBlur={formik.handleBlur}
          value={formik.values.phone_number}
          formikTouched={formik.touched.phone_number}
          error={formik.errors.phone_number}
        />
      ),
    },
  ];

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-12"
    >
      <div className="flex flex-col gap-4">
        <TabsRoot
          tabs={tabsData}
          defaultValue="email"
          isSub
          onValueChange={handleChangeTab}
        />
        <FloatingInputField
          id="password"
          name="password"
          label={t("signIn.password")}
          required={true}
          type="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
          formikTouched={formik.touched.password}
          error={formik.errors.password}
          showDefaultValidation={true}
        />
      </div>
      <div className="flex flex-col gap-6">
        {/* <Text variant="small" className="text-center">
          {t("userDelete.description")}
        </Text> */}
        <DefaultButton
          type="submit"
          label={t("userDelete.myDeleteAccount")}
          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
        />
      </div>
    </form>
  );
};

export default DeleteAccountForm;
